export const QUERY_PAYMENT_CARDS = "QUERY_PAYMENT_CARDS";
